var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"features page-content"},[_c('SearchSection'),_c('ImageRightSection'),_c('ImageLeftSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }